import "./index.css";

import styles from "@app/App.module.css";
import { GTM_ID } from "@components/Elements/GAData/GADataConstants";
import useSessionRefresh from "@hooks/useSessionRefresh";
import { Route } from "@route-types/../+types/root";
import { LightboxProvider } from "@sphtech/idpf-lightbox-react";
import NeuronProvider from "@web2/providers/NeuronProvider";
import * as React from "react";
import { StrictMode, useEffect } from "react";
import TagManager from "react-gtm-module";
import {
  isRouteErrorResponse,
  Outlet,
  ScrollRestoration,
  useLocation,
} from "react-router";

import { ENABLE_MYBH } from "./config/followTopic";
import { IS_PLAYWRIGHT_TEST } from "./helper/getEnvVariables";
import { BaseLayout, OauthLayout } from "./Layouts";
import HeadScriptProvider from "./providers/HeadScriptProvider";
import MyBHFollowedKeywords from "./routes/MyBH/MyBHFollowedKeywords";

function SessionRefreshHandler() {
  useSessionRefresh();
  return null;
}

// Wrapper component that sets up the HTML shell and global scripts

export function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  if (location.pathname.startsWith("/oauth/callback")) {
    console.log("Rendering Separate Layout for Oauth Page");
    return <OauthLayout>{children}</OauthLayout>;
  }

  return <BaseLayout>{children}</BaseLayout>;
}

// Main application component
export default function App() {
  useEffect(() => {
    TagManager.initialize({
      gtmId: GTM_ID,
      // optional settings (most people add these)
      auth: "", // if you use gtm auth (preview mode)
      preview: "", // if you use preview environment
      dataLayerName: "dataLayer", // default is 'dataLayer'
    });
  }, []);
  return (
    <StrictMode>
      {IS_PLAYWRIGHT_TEST !== "true" && (
        <>
          <HeadScriptProvider />
        </>
      )}
      <NeuronProvider>
        <LightboxProvider>
          <SessionRefreshHandler />
          <ScrollRestoration />
          {IS_PLAYWRIGHT_TEST === "true" ? (
            <></>
          ) : (
            <>
              {ENABLE_MYBH && <MyBHFollowedKeywords />}
              <div id="MyPageOverlay" className={styles.overlayWhite}></div>
              <div id="postitial_holder"></div>
              <div id="innity-flexframe-xxl-placeholder"></div>
            </>
          )}
          <Outlet />
        </LightboxProvider>
      </NeuronProvider>
    </StrictMode>
  );
}

// Runs in the browser and catches errors that occur during rendering of React components on the client.
// I.e Catches that occur during CLIENT side routing
// Errors during rendering, lifecycle methods, and constructors in the React component tree.
export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
  if (isRouteErrorResponse(error)) {
    return (
      <>
        <h1>is Route Error Response</h1>
        <h1>
          {error.status} {error.statusText}
        </h1>
        <p>{error.data}</p>
      </>
    );
  } else if (error instanceof Error) {
    return (
      <div>
        <h1>Error</h1>
        <p>{error.message}</p>
        <p>The stack trace is:</p>
        <pre>{error.stack}</pre>
      </div>
    );
  } else {
    return <h1>Unknown Error</h1>;
  }
}
